import { createBrowserRouter } from 'react-router-dom';

import { HomePage } from '@/pages/HomePage';
import { RewardPage } from '@/pages/RewardPage';

/**
 * 앱 라우트 정의.
 *
 * - `/`        — 코드 입력 페이지
 * - `/reward`  — 보상 다운로드 페이지 (3/3 완료 후 접근)
 *
 * 권한 미충족 라우트는 페이지 컴포넌트 내부에서 `<Navigate />`로 직접 처리한다.
 */
export const router = createBrowserRouter([
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/reward',
    element: <RewardPage />,
  },
  {
    path: '*',
    element: <HomePage />,
  },
]);
